import { Component, EventEmitter, Input, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { InternalFilterGroup, FilterItem, FilterChange } from 'app/shared/models/filter-group.models';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-number-filter',
    templateUrl: './number-filter.component.html',
    styleUrls: ['./number-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NumberFilterComponent {

  @Input() filter: InternalFilterGroup;
  @Input() dataToView: FilterItem[] = [];
  @Input() suffix: string;

  @Output() change = new EventEmitter<FilterChange>();

  filterOptions = new BehaviorSubject<FilterItem[]>([]);

  utilsFunction = UtilityFunctions;

  constructor(
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataToView) {
      this.filterOptions.next(this.dataToView);
    }
  }

  onChange(group: InternalFilterGroup) {
    group.data = this.filterOptions.value;
  }

}
